import { logger } from '@luna/logger';

import { querySettingsIfNeeded } from './useSettings';
import { registerUserConfigurationLegacySaveStrategy } from './configuration/UserConfigurationLegacySaveStrategy';
import { getUserConfigurationCollection } from './configuration/getUserConfigurationCollection';

function loadUserConfiguration(): Promise<void> {
    registerUserConfigurationLegacySaveStrategy();
    return new Promise((resolve, reject) => {
        const userConfigurations = getUserConfigurationCollection();
        userConfigurations.fetch({
            success() {
                userConfigurations.addFrontendConfig();
                resolve();
            },
            error(model: unknown, response: unknown, options: unknown) {
                logger.error('UserConfigurationError : ', model, response, options);
                reject();
            },
        });
    });
}

function loadSettings(): Promise<void> {
    return new Promise((resolve, reject) => {
        querySettingsIfNeeded().then(
            () => {
                resolve();
            },
            (err) => {
                logger.error('SettingsError : ', err);
                reject();
            },
        );
    });
}
export async function loadUserSettings(): Promise<void> {
    return Promise.all([loadUserConfiguration(), loadSettings()]).then();
}
